// @flow
import type {
  RPS_CLOSED_TYPE,
  RPS_DISCONNECTED_TYPE,
  RPS_OPEN_STARTED_TYPE,
  RPS_OPENED_TYPE,
  RPS_ERROR_OCCURRED_TYPE,
  RPS_JOIN_STARTED_TYPE,
  RPS_JOINED_TYPE,
  RPS_JOIN_FAILED_TYPE,
  RPS_TIMED_OUT_TYPE,
  RPS_DISJOINED_TYPE,
  RPS_PUSHED_TYPE,
} from '../types/socket';
import * as types from '../types/socket';

export const close = (host: string, userId: any, data: Object = {}): RPS_CLOSED_TYPE => ({
  type: types.RPS_CLOSED,
  payload: { host, userId, data },
});

export const disconnect = (host: string): RPS_DISCONNECTED_TYPE => ({
  type: types.RPS_DISCONNECTED,
  payload: { host },
});

export const open = (
  host: string,
  userId: any,
  token: string,
  role: string,
  defaultRooms: Array<string> = [],
): RPS_OPEN_STARTED_TYPE => ({
  type: types.RPS_OPEN_STARTED,
  payload: {
    host,
    userId,
    token,
    role,
    defaultRooms,
  },
});

export const completeOpen = (host: string, userId: any): RPS_OPENED_TYPE => ({
  type: types.RPS_OPENED,
  payload: { host, userId },
});

export const doError = (data: Object): RPS_ERROR_OCCURRED_TYPE => ({
  type: types.RPS_ERROR_OCCURRED,
  payload: { data },
});

export const join = (
  userId: any,
  token?: string,
  role?: string,
  channelId: string,
): RPS_JOIN_STARTED_TYPE => ({
  type: types.RPS_JOIN_STARTED,
  payload: {
    userId, token, role, channelId,
  },
});

export const completeJoin = (userId: any, channelId: string): RPS_JOINED_TYPE => ({
  type: types.RPS_JOINED,
  payload: { userId, channelId },
});

export const failJoin = (userId: any, channelId: string, data: Object): RPS_JOIN_FAILED_TYPE => ({
  type: types.RPS_JOIN_FAILED,
  payload: { userId, channelId, data },
});

// TODO: check the data shape that comes from fail join, in order to copy it here
export const doTimeout = (channelId: string, data: Object = { message: 'timeout' }): RPS_TIMED_OUT_TYPE => ({
  type: types.RPS_TIMED_OUT,
  payload: { channelId, data },
});

export const disjoin = (userId: any, channelId: string): RPS_DISJOINED_TYPE => ({
  type: types.RPS_DISJOINED,
  payload: { userId, channelId },
});

export const push = (channelId: string, eventName: string, data?: Object): RPS_PUSHED_TYPE => ({
  type: types.RPS_PUSHED,
  payload: { channelId, eventName, data },
});

// export const doChannelError = (channelId: string, data: Object) => ({
//   type: types.RPS_CHANNEL_ERROR_OCCURRED,
//   payload: { channelId, data }
// });



// WEBPACK FOOTER //
// ./src/scripts/actions/socket.js